<template>
  <main id="app" class="relative">          
      <router-view />      
      <!-- <Footer /> -->
  </main>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Authorization from "@/services/user/auth.service";

export default {
  components: {
    Footer
  },  
  data() {
    return {
      showMobileMenu: false,
    };
  },  
  created() {
    this.loginAPI()    
    if (!Authorization.isClientLogged()) {
      this.$router.push({name:'Login'})     
    }
  },
  methods: {
    async loginAPI() {
        await Authorization.login()          
    },
  },
};
</script>

<style>
:root {
  --orange: #E4A91D;
  --red: #bb2a1f;
  --blue: #232E6E;
  /* //0c3130  */
  --light-blue: #a4c2fc;
  --dark-blue: #1D1A39;
  --variable: #4640F8;
  --medium-gray: #c4c4c4;
  --light-gray: #e2e6ee;
  --dark-gray: #4b4b4b;
  --hovershadow: 0px 0px inherit inherit;
}

@font-face {
    font-family: 'Clarissa';
    src: url(assets/fonts/Clarissa.ttf) format("truetype");
 }
 
 @font-face {
    font-family: 'DINPro';
    src: url(assets/fonts/DINPro.ttf) format("truetype");
 }
 @font-face {
    font-family: 'DINPro-Bold';
    src: url(assets/fonts/DINPro-Bold.ttf) format("truetype");
 }
 @font-face {
    font-family: 'DINPro-Medium';
    src: url(assets/fonts/DINPro-Medium.ttf) format("truetype");
 }
 
 @font-face {
   font-family: 'Servicios';
   src: url(assets/fonts/Servicios.ttf) format("truetype");
 }

#app {
  font-family: DINPro, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  background-color: #e2e6ee;  
  min-height: 960px;
}
</style>
